import * as ng from 'angular';
import * as _ from 'underscore';

ng.module('selfReg')
   .directive('locationLookup', locationLookupDirective);

export function locationLookupDirective() {
   return {
      link: locationLookupDirectiveLink,
      restrict: 'A',
      scope: {
         lookupCountry: '<',
         onPickPlace: '&'
      }
   };
}

interface MyScope extends ng.IScope {
   lookupCountry:string;
   onPickPlace(place);
}

function locationLookupDirectiveLink(scope:MyScope, element:ng.IAugmentedJQuery) {
   let input = element[0] as HTMLInputElement;

   let autocomplete = new google.maps.places.Autocomplete(input);

   autocomplete.addListener('place_changed', onPlaceChanged);

   scope.$watch<string>('lookupCountry', countryCode => {
      autocomplete.setComponentRestrictions({country: countryCode});
   });

   function onPlaceChanged() {
      let place = autocomplete.getPlace();

      if (!place.geometry) {
         return;
      }

      let streetNumber = findAddressComponent(place, 'street_number', true);
      let locality = findAddressComponent(place, 'locality', true);

      let address = findAddressComponent(place, 'route');
      let address2:string;

      if (streetNumber) {
         address = streetNumber + ' ' + address;
      }

      let city = findAddressComponent(place, 'postal_town', true);
      if (city) {
         address2 = locality;
      } else {
         city = locality;
      }

      let stateCode = findAddressComponent(place, 'administrative_area_level_1');
      let countryCode = findAddressComponent(place, 'country');
      let postalCode = findAddressComponent(place, 'postal_code');

      // notify place change inside angular digest loop
      scope.$apply(function() {
         scope.onPickPlace({$place: {
            address: address,
            address2: address2,
            city: city,
            stateCode: stateCode,
            postalCode: postalCode,
            countryCode: countryCode
         }});
      });
   }
}

function findAddressComponent(place:google.maps.places.PlaceResult, componentName:string, long = false) {
   let result = _.find(place.address_components, function(addrComp) {
      return _.contains(addrComp.types, componentName);
   });
   if (result) {
      return long ? result.long_name : result.short_name;
   }
   return null;
}
